export default "__VITE_ASSET__8831c70b__"